import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Modal from "../components/Modal";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { resetModal, updateModal } from "../actions/modal";
import { portalConfig } from "../lib/portal";
import { updateExperiment } from "../actions/experiment";

class ModalContainer extends PureComponent {
  componentDidMount() {
    document.body.classList.remove(`${CSS_CLASS_PREFIX}-modal-open`);
  }

  componentDidUpdate(prevProps) {
    const { data, type } = this.props;

    if (prevProps.data !== data || prevProps.type !== type) {
      if (type == null || data == null) {
        document.body.classList.remove(`${CSS_CLASS_PREFIX}-modal-open`);
      } else {
        document.body.classList.add(`${CSS_CLASS_PREFIX}-modal-open`);
      }
    }
  }

  render() {
    const {
      clientConfig,
      data,
      offerType,
      resetModal,
      type,
      updateExperiment,
      updateModal
    } = this.props;

    return (
      <Modal
        clientConfig={clientConfig}
        data={data}
        offerType={offerType}
        portal={this.portal()}
        resetModal={resetModal}
        type={type}
        updateExperiment={updateExperiment}
        updateModal={updateModal}
      />
    );
  }

  portal() {
    const { portalId } = this.props;
    return portalConfig(portalId);
  }
}

function mapStateToProps(state) {
  return {
    clientConfig: state.clientConfig,
    data: state.modal.data,
    offerType: state.offerType,
    portalId: state.portalId,
    type: state.modal.type
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetModal: () => {
      dispatch(resetModal());
    },
    updateExperiment: experimentId => {
      dispatch(updateExperiment(experimentId));
    },
    updateModal: (data, type) => {
      dispatch(updateModal(data, type));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { updateExperiment } = dispatchProps;
  const { clientConfig } = stateProps;

  let updateExperimentValue = false;
  if (clientConfig.options.abTesting) {
    updateExperimentValue = function(experimentId) {
      updateExperiment(experimentId);
    };
  }

  return {
    ...stateProps,
    ...dispatchProps,
    updateExperiment: updateExperimentValue
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ModalContainer);
